


import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import EditIcon from "@mui/icons-material/Edit";
import LogoutIcon from "@mui/icons-material/Logout";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const BrandHeader = ({ page, notifications = [] }) => {
  const [showModal, setShowModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [brandData, setBrandData] = useState({});
  const isMenuOpen = Boolean(anchorEl);
  const navigate = useNavigate();
  const isMobile = window.innerWidth < 768;

  const getBrandData = async () => {
    try {
      const brandId = localStorage.getItem("brandID");
      if (!brandId) return;

      const response = await fetch(
        `https://server-side-influencer.onrender.com/brand/getBrandData/${brandId}`
      );
      const data = await response.json();
      setBrandData(data.data);
    } catch (err) {
      console.log(err);
      if (err.response?.status === 422) {
        navigate("/");
      } else {
        toast.error("An error occurred. Please try again later.");
      }
    }
  };

  useEffect(() => {
    getBrandData();
  }, []);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEditProfile = () => {
    handleMenuClose();
     navigate("/BrandProfile"); 
    // Add navigation or modal logics
  };

  
  const handleLogout = () => {
    try {
      localStorage.clear();
      sessionStorage.clear();
      document.cookie.split(";").forEach((cookie) => {
        const cookieName = cookie.split("=")[0].trim();
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      });
      window.open("https://smesh.in/", "_blank");
    } catch (err) {
      console.log("Error during logout:", err);
      window.open("https://smesh.in/", "_blank");
    }
  };


  const handleOutsideClick = (event) => {
    if (event.target.id === "modalOverlay") {
      setShowModal(false);
    }
  };

  return (
    !isMobile && (
      <div className="h-20 flex items-center ml-2 justify-between mx-auto w-full mt-0 ml-0 px-6 sm:px-10 border border-gray-200 shadow-md rounded-2xl bg-white">
        <nav>
          <p className="font-bold text-xl ml-10">Brand &gt; {page}</p>
        </nav>

        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-4">
            <div onClick={() => setShowModal(true)} className="flex items-center space-x-4 cursor-pointer">
              {/* <Link to="/notifybrand" className="flex items-center relative"> */}
                <div className="relative cursor-pointer">
                  <NotificationsIcon className="text-xl ml-3" />
                  {Array.isArray(notifications) && notifications.length > 0 && (
                    <div className="absolute -top-2 -right-2 w-5 h-5 bg-red-600 text-white text-xs rounded-full flex items-center justify-center">
                      {notifications.length}
                    </div>
                  )}
                </div>
              {/* </Link> */}
              <img
                className="w-10 h-10 rounded-full shadow-sm ml-4 object-cover border"
                src={brandData.brandbackgroundimage || "https://i.postimg.cc/brqZVdrP/dummypic.jpg"}
                alt="Brand Logo"
              />
            </div>

            <div
              className="flex items-center space-x-1 font-medium hover:text-blue-700 cursor-pointer"
              onClick={handleMenuClick}
            >
              <span>Hi, {brandData.shopName || "Brand"}</span>
              {isMenuOpen ? (
                <ArrowDropUpIcon fontSize="large" className="text-3xl" />
              ) : (
                <ArrowDropDownIcon fontSize="large" className="text-3xl" />
              )}
            </div>

            <Menu
              anchorEl={anchorEl}
              open={isMenuOpen}
              onClose={handleMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem onClick={handleEditProfile}>
                <EditIcon className="mr-2" fontSize="small" />  Profile
              </MenuItem>
              <MenuItem onClick={handleLogout}>
                <LogoutIcon className="mr-2" fontSize="small" /> Logout
              </MenuItem>
            </Menu>
          </div>
        </div>

        {showModal && (
          <div
            id="modalOverlay"
            onClick={handleOutsideClick}
            className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          >
            <img
              className="w-64 h-64 rounded-full border-4 border-white shadow-2xl object-cover"
              src={brandData.brandbackgroundimage || "https://i.postimg.cc/brqZVdrP/dummypic.jpg"}
              alt="Large Profile"
            />
          </div>
        )}
      </div>
    )
  );
};

export default BrandHeader;
